import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { Switch } from "@material-ui/core";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { alpha, makeStyles, styled } from "@material-ui/core/styles";
import swal from "sweetalert";
import "./index.css";
import axios from "axios";
import UrlLinks from "../../../UrlLinks";
import { useHistory, useParams } from "react-router-dom";
import styles from "./index.module.scss";
import { AppData } from "../../../context/context";
import { useContext } from "react";
import LocationModal from "../LocationModal";
import LocationComponent from "./LocationComponent";
import TextEditor from "./InputComponents/TextEditor";
import { CloseRounded, LockOutlined } from "@material-ui/icons";
import {
  ContentCopy,
  FileDownloadOutlined,
  FileUploadOutlined,
} from "@mui/icons-material";
import pdfIcon from "../Assets/pdfIcon.svg";
import videoIcon from "../Assets/videoIcon.svg";
import fileIcon from "../Assets/fileIcon.svg";
import { copyToClipboard } from "../../../Utils/CommonFunctions";
import Header from "../components/Header";
import AgeRequirement from "../components/AgeRequirement";
import GenderLanguage from "../components/GenderLanguage";
import AutoSelect from "../components/AutoSelect";
import EducationAssetRequirement from "../components/EducationAssetRequirement";
import Footer from "../components/Footer";

const locationDataTemplate = "/locationData-template.xlsx";

const useStyles = makeStyles({});

const formatFileSize = (sizeInBytes) => {
  if (sizeInBytes < 1024) {
    return sizeInBytes + " B";
  } else if (sizeInBytes < 1024 * 1024) {
    return (sizeInBytes / 1024).toFixed(2) + " KB";
  } else if (sizeInBytes < 1024 * 1024 * 1024) {
    return (sizeInBytes / (1024 * 1024)).toFixed(2) + " MB";
  } else {
    return (sizeInBytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
  }
};

const JobConfigForm = (data) => {
  const classes = useStyles();
  const history = useHistory();
  const { jobId } = useParams();
  const {
    Loader,
    jobConfigMode,
    setJobConfigMode,
    setEligibilityJobId,
    eligibilityOptionList,
    setEligibilityOptionList,
  } = useContext(AppData);

  /* Other states */

  const [formData, setFormData] = useState({
    attachmentName: "",
    attachmentNeeded: false,
    attachmentSize: "",
    is_mpa_enable: false,
    jobDesc: "",
    jobTitle: "",
    jobType: "",
    jobTypeLocation: "",
    locationMethod: "",
    locations: [],
    locationSearch: "",
    locationType: "hublocations",
    mpa_url: "",
    projectName: "",
    shiftTimings: "",
  });
  const [isNotEditable, setIsNotEditable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [goodToSave, setGoodToSave] = useState(false);
  const [showLocationList, setShowLocationList] = useState(false);
  const [showLanguageList, setShowLanguageList] = useState(false);
  const [eligibilityData, setEligibilityData] = useState(null);
  const [getData, setGetData] = useState("");
  const [selectedAttachments, setSelectedAttachments] = useState([]);
  const [attachment, setAttachment] = useState(null);
  const [selectedLocationFile, setSelectedLocationFile] = useState([]);
  const [excel, setExcel] = useState(null);
  const [fileSizeErr, setFileSizeErr] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const fileInputRef = useRef(null);
  const locationFileInputRef = useRef(null);
  const [limitExceeded, isLimitExceeded] = useState(false);
  const [isMpaEnable, setIsMpaEnable] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [shouldTruncate, setShouldTruncate] = useState(false);
  const [optionList, setOptionList] = useState({
    clientList: [],
    jobLocationList: [],
    jobTypeList: [],
    locationList: [],
    projectNameList: [],
    projectOwnerList: [],
    verticalList: [],
  });
  const [radioList, setRadioList] = useState({
    locationMethod: [],
    locationType: [],
  });
  const maxChars = 720;

  const cardOne = [
    {
      id: null,
      title: "Project Name",
      isLock: true,
      valueKey: "projectName",
      multipleFlag: false,
      placeHolder: "Type or select project name",
      list: optionList.projectNameList,
      disabled: isNotEditable,
      type: "dropdown",
      isMandatory: true,
    },
    {
      id: 1,
      title: "Job Title",
      isLock: true,
      valueKey: "jobTitle",
      multipleFlag: false,
      placeHolder: "Type your Job Title",
      list: optionList.projectNameList,
      disabled: isNotEditable,
      type: "textbox",
      isMandatory: true,
    },
    {
      id: 4,
      title: "Job type",
      isLock: true,
      valueKey: "jobType",
      multipleFlag: false,
      placeHolder: "Select Job Type",
      list: optionList.jobTypeList,
      disabled: isNotEditable,
      type: "dropdown",
      isMandatory: true,
    },
    {
      id: 3,
      title: "Location Type",
      isLock: true,
      valueKey: "jobTypeLocation",
      multipleFlag: false,
      placeHolder: "Select Location Type",
      list: optionList.jobLocationList,
      disabled: isNotEditable,
      type: "dropdown",
      isMandatory: true,
    },
    {
      id: null,
      title: "Shift Timings",
      isLock: false,
      valueKey: "shiftTimings",
      multipleFlag: false,
      placeHolder: "Select Shift Timings",
      list: eligibilityOptionList.shiftTimings,
      disabled: false,
      type: "dropdown",
      isMandatory: true,
    },
  ];
  const cardTwo = [
    {
      id: 5,
      title: "Job Description",
      valueKey: "jobDesc",
      placeHolder:
        "Describe the Job requirements, responsibilities & qualifications...",
      type: "textbox",
      isMandatory: true,
    },
    {
      id: null,
      title: "Attachments",
      valueKey: "attachmentName",
      placeHolder:
        "(attachments will give the applicant a better clarity on the job)",
      type: "upload",
      isMandatory: false,
    },
    {
      id: null,
      title: "",
      valueKey: "attachment",
      placeHolder: "",
      errorMessage: "File size should be less than 10 MB",
      type: "file",
      isMandatory: false,
    },
  ];
  const cardThree = [
    {
      id: 8,
      title: "Choose Location Method",
      valueKey: "locationMethod",
      type: "nestedBox",
      list: radioList?.locationMethod,
      isMandatory: true,
      isDisabled:
        !formData.projectName ||
        !formData.jobTypeLocation ||
        formData.jobTypeLocation?.name === "Remote",
      childObj: {
        fileUpload: [
          {
            id: 6,
            title: "Select Location Type",
            valueKey: "locationType",
            list: radioList?.locationType,
            type: "radio",
          },
          {
            id: 1.2,
            title: "",
            valueKey: "",
            list: [
              {
                id: "b1",
                title: "Download Template",
              },
              {
                id: "b2",
                title: "Browse File",
              },
            ],
            type: "button",
          },
        ],
        manualUpload: [
          {
            id: 6,
            title: "Select Location Type",
            valueKey: "locationType",
            placeHolder: "",
            list: radioList?.locationType,
            multipleFlag: false,
            isDisabled: false,
            type: "radio",
          },
          {
            id: 1.2,
            title: "Search & Select Cities",
            valueKey: "locations",
            placeHolder: "Type or Search Cities",
            list: optionList?.locationList,
            multipleFlag: true,
            isDisabled: !formData.locationType,
            type: "dropdown",
          },
          {
            id: 1.3,
            title: "Selected Locations",
            valueKey: "locations",
            placeHolder: "",
            list: formData?.locations || [],
            multipleFlag: false,
            isDisabled: false,
            type: "chips",
          },
        ],
      },
    },
  ];
  const cardFour = [
    {
      id: null,
      title: "MPA Link",
      valueKey: "generateMpa",
      placeHolder: "Generate a shareable link for MPA workers",
      type: "toggle",
      isLock: true,
      isMandatory: false,
      isDisabled:
        jobConfigMode === "view" ||
        (jobConfigMode === "edit" && formData.is_mpa_enable)
          ? true
          : false,
      childArr: [
        {
          title: "Generated MPA Link",
          valueKey: "mpa_url",
        },
      ],
    },
  ];
  const cardView1 = [
    {
      id: null,
      title: "Age Requirements",
      valueKey: "",
      placeHolder: "Set the minimum and maximum age limits for eligibility",
      type: "header",
    },
    {
      id: null,
      title: "Minimum Age",
      valueKey: "fromAge",
      placeHolder: "",
      type: "textbox",
    },
    {
      id: null,
      title: "Maximum Age",
      valueKey: "toAge",
      placeHolder: "",
      type: "textbox",
    },
    {
      id: null,
      title: "Current range",
      valueKey: "",
      placeHolder: "",
      type: "answer-box",
    },
  ];
  const cardView2 = [
    {
      title: "Gender",
      valueKey: "gender",
      placeHolder: "Select gender requirements for eligibility",
      type: "dropdown",
    },
    {
      title: "Language",
      valueKey: "language",
      placeHolder: "Select required languages",
      type: "chips",
    },
  ];
  const cardView3and4 = [
    {
      title: "Education",
      valueKey: "education",
      placeHolder: "Minimum education requirement",
      list: eligibilityOptionList.educationList,
      type: "radio",
      isDisabled: true,
    },
    {
      title: "Assets Requirements",
      valueKey: "assets",
      placeHolder: "Select required asset types for eligibility verification",
      list: eligibilityOptionList.assetList,
      type: "checkbox",
      isDisabled: true,
    },
  ];

  const plainText = (htmlContent) => {
    const temp = document.createElement("div");
    temp.innerHTML = htmlContent || "";

    return temp.textContent || temp.innerText || "";
  };

  // Function to check if all required values are present
  const checkFormData = () => {
    const requiredFields = [
      "projectName",
      "jobDesc",
      "jobTitle",
      "jobType",
      "jobTypeLocation",
      "shiftTimings",
    ];

    const jobTypeValue = formData["jobTypeLocation"]?.id;
    if (jobTypeValue === 6) {
      requiredFields.push("locationMethod");
    }

    const allFieldsPresent = requiredFields.every((field) => {
      if (field === "jobTypeLocation") {
        return !!formData[field];
      }
      if (field === "locationMethod") {
        return formData[field] === "manualUpload"
          ? formData.locations.length > 0
          : selectedLocationFile.length > 0;
      }
      if (field === "jobDesc") {
        const parser = new DOMParser();
        const description = parser.parseFromString(
          formData[field],
          "text/html"
        );
        const plainText = description.body.textContent || "";
        return plainText.length > 0;
      }
      if (Array.isArray(formData[field])) {
        return formData[field].length > 0;
      } else {
        return formData[field] !== "";
      }
    });

    return allFieldsPresent;
  };

  const makeProjectNameList = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.projects_key,
        name: el.project_name,
        projectId: el.projects_id,
      });
      return true;
    });
    return list;
  };

  const makeShiftList = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.id,
        name: el.typeValue,
      });
      return true;
    });
    return list;
  };

  const makeLocationList = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.id,
        name: el.name,
      });
      return true;
    });
    return list;
  };

  const handleOpenUploadedFile = () => {
    if (attachment) {
      const fileURL = URL.createObjectURL(attachment);
      window.open(fileURL, "_blank");
    } else {
      console.log("No file uploaded.");
    }
  };

  const getLocationList = () => {
    if (
      formData &&
      formData.locationSearch &&
      formData.locationSearch.length > 2
    ) {
      Axios.get(
        `${UrlLinks.baseUrl}task-job/getLocations?key=${formData.locationSearch}&locationType=${formData.locationType}&projectId=${formData.projectName.projectId}`
      ).then((response) => {
        setOptionList((prev) => ({
          ...prev,
          locationList: response.data.response
            ? makeLocationList(response.data.response)
            : [],
        }));
      });
    }
  };

  const getTruncatedHtml = (htmlContent) => {
    const temp = document.createElement("div");
    temp.innerHTML = htmlContent;

    let currentLength = 0;
    let truncatedHtml = "";

    const traverseNodes = (node) => {
      if (currentLength >= maxChars) return;

      if (node.nodeType === Node.TEXT_NODE) {
        const remaining = maxChars - currentLength;
        const text = node.textContent;

        if (text.length <= remaining) {
          currentLength += text.length;
          truncatedHtml += text;
        } else {
          truncatedHtml += text.slice(0, remaining) + "...";
          currentLength += remaining;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        truncatedHtml += `<${node.tagName.toLowerCase()}>`;
        node.childNodes.forEach(traverseNodes);
        truncatedHtml += `</${node.tagName.toLowerCase()}>`;
      }
    };

    temp.childNodes.forEach(traverseNodes);
    return truncatedHtml;
  };

  const handleClick = (e, type) => {
    switch (type) {
      case "descExpand": {
        setExpanded(!expanded);
        break;
      }
      default:
        break;
    }
  };

  const handleChange = (event, type) => {
    switch (type) {
      case "generateMpa": {
        setIsMpaEnable(event.target.checked ? 1 : 0);
        break;
      }
      default:
        break;
    }
  };

  const handleInputChange = (e, type) => {
    if (type === 1) {
      setFormData((prev) => ({
        ...prev,
        jobTitle: e.target.value.replace(/[^a-zA-Z ]/gi, ""),
      }));
    }
    if (type === 3) {
      setFormData((prev) => ({ ...prev, jobTypeLocation: e.target.value }));
    }
    if (type === 4) {
      setFormData((prev) => ({ ...prev, jobType: e.target.value }));
    }
    if (type === 5 && formData.jobDesc.length < 2001) {
      setFormData((prev) => ({ ...prev, jobDesc: e.target.value }));
    }
    if (type === 8) {
      setFormData((prev) => ({ ...prev, locationMethod: e.target.value }));
    }
    if (type === 6) {
      setFormData((prev) => ({
        ...prev,
        locationType: e.target.value,
        locations: [],
      }));
      setSelectedLocationFile([]);
    }
  };

  const handleSaveBtn = () => {
    try {
      setIsLoading(true);

      const mainData = { ...formData };
      mainData.attachmentName =
        selectedAttachments && selectedAttachments.length > 0
          ? selectedAttachments[0].name
          : formData.attachmentName;
      mainData.attachmentSize =
        selectedAttachments && selectedAttachments.length > 0
          ? formatFileSize(selectedAttachments[0].size)
          : formData.attachmentSize;
      mainData.is_mpa_enable = isMpaEnable ? true : false;
      const formData1 = new FormData();
      formData1.append("attachment_file_1", attachment);
      formData1.append("file", excel);

      const body = JSON.stringify({
        jobDesc: mainData.jobDesc,
        jobId: jobId !== "add" ? jobId : null,
        jobTitle: mainData.jobTitle,
        jobType: +mainData.jobType?.id,
        jobTypeLocation: +mainData.jobTypeLocation?.id,
        locationType: mainData.locationType,
        locations: mainData.locations ? mainData.locations : null,
        projectId: mainData.projectName.projectId,
        shiftTimings: mainData.shiftTimings.id,
        attachmentNeeded: mainData.attachmentNeeded,
        is_mpa_enable: isMpaEnable ? 1 : 0,
      });
      formData1.append("body", body);
      formData1.append("page1", JSON.stringify(mainData));

      const userId = localStorage.getItem("userID");

      axios
        .post(
          `${UrlLinks.baseUrl}task-job/addEditJob?insertedBy=${userId}`,
          formData1,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "*/*", // Update the accept header here
            },
          }
        )
        .then((res) => {
          if (res.data.code !== 1000) {
            setIsLoading(false);
            swal(
              "Uploaded location data is not present in the system.",
              "",
              "error"
            );
          } else {
            setEligibilityJobId(res.data.response);
            setIsLoading(false);
            history.push(`/jobsdb/eligibilityCriteria/${res.data.response}`);
          }
        });
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false);
      swal(error, "", "error");
    }
  };

  const handleFileUpload = (e) => {
    const maxSize = 10 * 1024 * 1024;
    const files = e.target.files;
    setAttachment(files[0]);
    if (files.length > 0 && files[0].size <= maxSize) {
      const allowedTypes = [
        "video/mp4",
        "video/quicktime",
        "video/x-matroska",
        "application/pdf",
      ];
      const validFiles = Array.from(files).filter((file) =>
        allowedTypes.includes(file.type)
      );
      if (validFiles.length > 0) {
        setSelectedAttachments(validFiles);
        setFormData((prev) => ({ ...prev, attachmentNeeded: true }));
        // Clear the input value to reset it
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setFileSizeErr(false);
      } else {
        // Display an error message or toast indicating invalid file types
        console.error("Invalid file types. Please select valid files.");
      }
    } else {
      setFileSizeErr(true);
    }
  };

  const handleLocationFileUpload = (e) => {
    const files = e.target.files;
    setExcel(files[0]);
    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    const validFiles = Array.from(files).filter((file) =>
      allowedTypes.includes(file.type)
    );

    if (validFiles.length > 0) {
      setSelectedLocationFile(validFiles);
      // Clear the input value to reset it
      if (locationFileInputRef.current) {
        locationFileInputRef.current.value = "";
      }
    } else {
      // Display an error message or toast indicating invalid file types
      console.error("Invalid file types. Please select valid files.");
    }
  };

  const removeAttachmentLink = () => {
    setFormData((prev) => ({
      ...prev,
      attachmentName: "",
      attachmentSize: "",
    }));
    setFormData((prev) => ({ ...prev, attachmentNeeded: false }));
  };

  const removeSelectedAttachment = (index) => {
    const updatedAttachments = selectedAttachments.filter(
      (_, i) => i !== index
    );
    setSelectedAttachments(updatedAttachments);
    removeAttachmentLink();
  };

  const removeSelectedLocationFile = (type, valueKey, data, index) => {
    switch (type) {
      case "manualUpload": {
        const updatedArray = formData[valueKey]?.filter(
          (item) => item?.id !== data.id
        );
        setFormData((prev) => ({
          ...prev,
          [valueKey]: updatedArray,
        }));
        break;
      }
      default:
        break;
    }
  };

  /* UseEffects */

  useEffect(() => {
    const isGoodToSave = checkFormData();
    setGoodToSave(isGoodToSave && !limitExceeded);
  }, [JSON.stringify(formData), selectedLocationFile, limitExceeded]);

  useEffect(() => {
    if (formData.jobTypeLocation === "5" && jobId === "add") {
      setFormData((prev) => ({
        ...prev,
        locations: [],
        locationSearch: "",
        attachmentName: "",
        attachmentSize: "",
      }));
      setSelectedAttachments([]);
    }
  }, [formData.jobTypeLocation]);

  useEffect(() => {
    if (formData.locationType) {
      getLocationList();
    }
  }, [formData.locationType, formData.locationSearch]);

  useEffect(async () => {
    setIsLoading(true);
    let currentFormMode = jobConfigMode;

    if (jobId !== "add") {
      currentFormMode = "view";
    }

    await Axios.get(
      `${UrlLinks.baseUrl}${UrlLinks.projectListing.mainListing}`
    ).then((response) => {
      setOptionList((prev) => ({
        ...prev,
        projectNameList: makeProjectNameList(response.data.response),
      }));
    });

    await Axios.get(`${UrlLinks.baseUrl}task-job/jobConfigValues`).then(
      (response) => {
        setEligibilityOptionList((prev) => ({
          ...prev,
          assetList: makeShiftList(response.data.assets),
          educationList: makeShiftList(response.data.education),
          shiftTimings: makeShiftList(response.data.shift),
        }));
      }
    );
    setOptionList((prev) => ({
      ...prev,
      jobTypeList: [
        {
          id: 2,
          name: "Part time",
        },
        {
          id: 1,
          name: "Full time",
        },
        {
          id: 4,
          name: "Part time & Full time Both",
        },
      ],
      jobLocationList: [
        {
          id: 5,
          name: "Remote",
        },
        {
          id: 6,
          name: "Field job",
        },
      ],
    }));
    setRadioList((prev) => ({
      ...prev,
      locationMethod: [
        {
          id: 1,
          value: "fileUpload",
          name: "File Upload Method",
        },
        {
          id: 2,
          value: "manualUpload",
          name: "Manual Upload Method",
        },
      ],
      locationType: [
        {
          id: 1,
          value: "hublocations",
          name: "Hub",
        },
        {
          id: 2,
          value: "city",
          name: "City",
        },
        {
          id: 3,
          value: "pincode",
          name: "Pincode",
        },
      ],
    }));

    if (jobId !== "add") {
      await Axios.get(`${UrlLinks.baseUrl}task-job/${jobId}`).then(
        (response) => {
          const newFormData = JSON.parse(response.data.page1);
          let newEligibilityData = JSON.parse(response.data.page2);

          if (!newEligibilityData) {
            newEligibilityData = {};
            newEligibilityData.assets = [];
            newEligibilityData.education = null;
            newEligibilityData.fromAge = "";
            newEligibilityData.gender = null;
            newEligibilityData.language = [];
            newEligibilityData.toAge = "";
          }
          const locations = response.data.locationArray;
          const descPlainText = plainText(response.data.desc);

          if (locations && locations.length > 0) {
            newFormData.locations = [...locations];
          }
          if (response.data.attachment && response.data.attachment.length > 0) {
            newFormData.attachmentNeeded = true;
          }
          newFormData.is_mpa_enable = response.data.is_mpa_enable;
          newFormData.mpa_url = response.data.mpa_url;
          newFormData.jobType = {
            id: response.data.jobType,
            name:
              response.data.jobType === 1
                ? "Full time"
                : response.data.jobType === 2
                ? "Part time"
                : response.data.jobType === 4
                ? "Part time & Full time Both"
                : "",
          };
          newFormData.jobTypeLocation = {
            id: response.data.jobTypeLocation,
            name:
              response.data.jobTypeLocation === 5
                ? "Remote"
                : response.data.jobTypeLocation === 6
                ? "Field job"
                : "",
          };
          newFormData.locationMethod = newFormData.locationMethod
            ? newFormData.locationMethod
            : newFormData.locations.length === 0
            ? "fileUpload"
            : "manualUpload";
          newFormData.locationType = newFormData.locationType
            ? newFormData.locationType
            : "hublocations";

          setFormData(newFormData);
          setGetData(response.data);
          setIsMpaEnable(response.data.is_mpa_enable ? 1 : 0);
          setShouldTruncate(descPlainText.length > maxChars);
          setEligibilityData(newEligibilityData);
        }
      );
    }

    setJobConfigMode(currentFormMode);
    setPageLoading(false);
    setIsLoading(false);
  }, []);

  const label = { inputProps: { "aria-label": "Switch demo" } };
  const BlueSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1C4980",
      "&:hover": {
        backgroundColor: alpha("#1C4980", theme.palette.action.hoverOpacity),
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1C4980",
    },
    "& .MuiSwitch-switchBase": {
      cursor: jobConfigMode === "view" ? "auto" : "pointer",
    },
  }));

  const templateButton = (type, i, bid, locationDataTemplate) => {
    return (
      <a
        key={i}
        href={locationDataTemplate}
        download
        target="_blank"
        className={`${styles.customButton}`}
      >
        <FileDownloadOutlined
          style={{
            color: "#9BA3AF",
            width: "24px",
            height: "24px",
          }}
        />
        {bid.title}
      </a>
    );
  };

  const browseButton = (type, i, bid, locationFileInputRef) => {
    return (
      <div key={i}>
        <label htmlFor="location-button-file">
          <div className={`${styles.customButton}`}>
            <FileUploadOutlined
              style={{
                color: "#9BA3AF",
                width: "24px",
                height: "24px",
              }}
            />
            {bid.title}
          </div>
        </label>
        <input
          style={{ display: "none" }}
          id="location-button-file"
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={(e) => handleLocationFileUpload(e)}
          ref={locationFileInputRef}
        />
      </div>
    );
  };

  const radioGroup = (
    type,
    id,
    rid,
    val,
    formLabelSx,
    radioGroupSx,
    formControlLabelSx
  ) => {
    return (
      <FormControl component="fieldset" key={id}>
        <FormLabel component="legend" sx={formLabelSx}>
          {rid.title}
        </FormLabel>
        <RadioGroup row sx={radioGroupSx}>
          {rid.list?.map((bid, i) => {
            return (
              <FormControlLabel
                key={i}
                value={bid.value}
                label={bid.name}
                checked={val === bid.value}
                onChange={(e) => handleInputChange(e, rid.id)}
                sx={formControlLabelSx}
                control={<Radio size="small" color="primary" />}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    );
  };

  const fileAttachement = (fileData, getData, formData) => {
    const fileExtension = formData?.attachmentName?.split(".");

    return fileData?.length > 0 ? (
      <div
        className={`flexDisplay justifyContentSpaceBetween ${styles.uploadBox} ${styles.solidGreyBorder}`}
      >
        {selectedAttachments.map((file, index) => (
          <React.Fragment key={index}>
            <span
              className={`flexDisplay justifyContentSpaceBetween`}
              style={{ alignItems: "center" }}
              onClick={handleOpenUploadedFile}
            >
              <img
                src={file.type === "application/pdf" ? pdfIcon : videoIcon}
                alt="icon"
              />
              <span
                style={{
                  color: "#2E2E2E",
                  marginLeft: "20px",
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontSize: "14px",
                }}
              >
                {file.name.length > 20
                  ? `${file.name.substring(0, 20)}...`
                  : file.name}
                &nbsp;
                <span
                  style={{
                    color: "black",
                  }}
                >
                  {`(${formatFileSize(file.size)})`}
                </span>
              </span>
            </span>
            <button
              className={styles.fileCloseBtn}
              onClick={() => removeSelectedAttachment(index)}
            >
              Remove
            </button>
          </React.Fragment>
        ))}
      </div>
    ) : getData &&
      getData.attachment &&
      formData.attachmentName &&
      formData.attachmentSize ? (
      <div
        className={`flexDisplay justifyContentSpaceBetween ${styles.uploadBox} ${styles.solidGreyBorder}`}
        style={{
          marginTop: jobConfigMode === "view" ? "-24px" : "",
        }}
      >
        <span
          className={`flexDisplay justifyContentSpaceBetween`}
          style={{ alignItems: "center" }}
        >
          <img
            src={
              fileExtension[fileExtension.length - 1] === "pdf"
                ? pdfIcon
                : videoIcon
            }
            alt="icon"
          />
          <a
            href={getData.attachment}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#2E2E2E",
              marginLeft: "20px",
              textDecoration: "underline",
              fontSize: "14px",
            }}
          >
            {formData.attachmentName.length > 20
              ? `${formData.attachmentName.substring(0, 20)}...`
              : formData.attachmentName}
            &nbsp;
            <span
              style={{
                color: "black",
              }}
            >
              {`(${formData.attachmentSize})`}
            </span>
          </a>
        </span>
        {jobConfigMode !== "view" && (
          <button
            className={styles.fileCloseBtn}
            onClick={() => removeAttachmentLink()}
          >
            Remove
          </button>
        )}
      </div>
    ) : null;
  };

  return (
    <>
      {pageLoading ? (
        Loader()
      ) : (
        <>
          <Box
            style={{
              padding: "50px 80px",
              boxSizing: "border-box",
              backgroundColor: "#f7fafc",
            }}
          >
            <Grid container className={styles.mainBox}>
              <Grid item xs={12} container className={`flexDisplay`}>
                <Header
                  uniqueKey="jobConfig"
                  title={
                    jobConfigMode === "create"
                      ? "Add Job Details 1/3"
                      : jobConfigMode === "view"
                      ? "View Job Details"
                      : "Edit Job Details"
                  }
                  helperText="Create a job that will be shown both in the app and website"
                  linkBack="/jobsdb"
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  setIsNotEditable={setIsNotEditable}
                />
              </Grid>
              <Grid
                item
                xs={12}
                container
                sx={{
                  justifyContent: "space-between",
                  rowGap: "60px",
                }}
                className={`${styles.cardContainer}`}
              >
                {cardOne?.map((ele, id) => (
                  <Grid
                    key={id}
                    item
                    sx={{
                      flex: "0 0 49%",
                      maxWidth: "49%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "14px",
                      }}
                    >
                      <Typography
                        className={`${styles.formFont} ${
                          (jobConfigMode === "create" ||
                            (ele.valueKey === "shiftTimings" &&
                              jobConfigMode !== "view")) &&
                          ele.isMandatory
                            ? styles.requiredField
                            : ""
                        }`}
                      >
                        <span>{ele.title}</span>
                        {jobConfigMode === "edit" && ele.isLock && (
                          <span
                            style={{
                              marginLeft: "8px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <LockOutlined
                              style={{
                                color: "#757575",
                                width: "16px",
                                height: "16px",
                              }}
                            />
                          </span>
                        )}
                      </Typography>
                      {jobConfigMode === "create" ? (
                        ele.type === "dropdown" ? (
                          <AutoSelect
                            data={formData}
                            setData={setFormData}
                            id={ele.valueKey}
                            multipleFlag={ele.multipleFlag}
                            placeHolder={ele.placeHolder}
                            list={ele.list}
                            disabled={ele.disabled}
                          />
                        ) : (
                          <FormControl
                            variant="outlined"
                            sx={{ width: "100%" }}
                          >
                            <TextField
                              fullWidth
                              id="outlined-adornment-weight"
                              aria-describedby="outlined-weight-helper-text"
                              className={styles.textComponent}
                              placeholder={ele.placeHolder}
                              value={formData[ele.valueKey]}
                              onChange={(e) => {
                                handleInputChange(e, ele.id);
                              }}
                              disabled={ele.disabled}
                              inputProps={{
                                "aria-label": "weight",
                              }}
                            />
                          </FormControl>
                        )
                      ) : (
                        <div
                          className={`${styles.textBoxView} ${styles.textBoxViewDisable}`}
                        >
                          {ele.valueKey === "jobTitle"
                            ? formData[ele.valueKey]
                            : formData[ele.valueKey].name}
                        </div>
                      )}
                    </Box>
                  </Grid>
                ))}
              </Grid>
              <Grid
                item
                xs={12}
                container
                sx={{
                  rowGap: "24px",
                }}
                className={`${styles.cardContainer}`}
              >
                {cardTwo?.map((ele, id) => (
                  <Grid key={id} item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "15px",
                      }}
                    >
                      <Typography className={`${styles.formFont}`}>
                        <span
                          className={`${
                            jobConfigMode !== "view" && ele.isMandatory
                              ? styles.requiredField
                              : ""
                          }`}
                        >
                          {ele.title}
                        </span>
                        {ele.type === "upload" && (
                          <span
                            className={`${styles.greydedText}`}
                            style={{
                              marginLeft: "4px",
                              fontSize: "12px",
                            }}
                          >
                            {ele.placeHolder}
                          </span>
                        )}
                      </Typography>
                      {jobConfigMode !== "view" ? (
                        ele.type === "upload" ? (
                          <div
                            className={`flexDisplayColumn ${styles.uploadBox} ${styles.dashedBorder}`}
                          >
                            <label
                              htmlFor="contained-button-file"
                              className="flexDisplay justifyContentCenter"
                              style={{ cursor: "pointer" }}
                            >
                              <FileUploadOutlined
                                style={{
                                  color: "#9BA3AF",
                                  width: "32px",
                                  height: "32px",
                                }}
                              />
                            </label>
                            <input
                              style={{ display: "none" }}
                              id="contained-button-file"
                              type="file"
                              accept=".mp4,video/*,.mov,video/*,.mkv,video/*,.pdf,application/pdf"
                              onChange={(e) => handleFileUpload(e)}
                              ref={fileInputRef}
                            />
                            <div className="flexDisplay justifyContentCenter">
                              Click to upload files or drag & drop
                            </div>
                            <div
                              className={`flexDisplay justifyContentCenter ${styles.greydedText}`}
                              style={{ marginTop: "5px", fontSize: "12px" }}
                            >
                              Attach only MP4, MOV, MKV or PDF upto 10MB
                            </div>
                          </div>
                        ) : ele.type === "file" &&
                          (selectedAttachments.length > 0 ||
                            getData[ele.valueKey]) ? (
                          <div>
                            {fileAttachement(
                              selectedAttachments,
                              getData,
                              formData
                            )}
                            {fileSizeErr && (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                }}
                              >
                                {ele.errorMessage}
                              </p>
                            )}
                          </div>
                        ) : ele.type === "textbox" ? (
                          <TextEditor
                            data={formData}
                            setData={setFormData}
                            id="jobDesc"
                            limitExceeded={limitExceeded}
                            isLimitExceeded={isLimitExceeded}
                          />
                        ) : null
                      ) : ele.type === "textbox" ? (
                        <div
                          className={`${styles.textBoxView} ${styles.textBoxViewDisable}`}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html:
                                (!expanded && !shouldTruncate) || expanded
                                  ? getData.desc
                                  : getTruncatedHtml(getData.desc),
                            }}
                          ></span>
                          {!!shouldTruncate && (
                            <button
                              className={`${styles.showMoreBtn}`}
                              style={{ background: "none", fontSize: "14px" }}
                              onClick={(e) => handleClick(e, "descExpand")}
                            >
                              {expanded ? `<< View less` : `View more >>`}
                            </button>
                          )}
                        </div>
                      ) : ele.type === "file" && getData[ele.valueKey] ? (
                        fileAttachement([], getData, formData)
                      ) : null}
                    </Box>
                  </Grid>
                ))}
              </Grid>
              {!cardThree[0]?.isDisabled && (
                <Grid
                  item
                  xs={12}
                  container
                  className={`${styles.cardContainer}`}
                >
                  {cardThree?.map((ele, id) => (
                    <Grid key={id} item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "15px",
                        }}
                      >
                        {jobConfigMode !== "view" ? (
                          <FormControl component="fieldset">
                            <FormLabel
                              component="legend"
                              className={`${styles.formFont} ${
                                ele.isMandatory ? styles.requiredField : ""
                              }`}
                              sx={{
                                color: "#2E2E2E",
                                marginBottom: "20px",
                                fontWeight: 500,
                                "&.Mui-focused": {
                                  color: "#2E2E2E",
                                },
                              }}
                            >
                              {ele.title}
                            </FormLabel>
                            <RadioGroup
                              row
                              sx={{
                                fontSize: "14px",
                              }}
                            >
                              {ele.list?.map((rid, index) => {
                                return (
                                  <FormControlLabel
                                    key={index}
                                    value={rid.value}
                                    label={rid.name}
                                    checked={
                                      formData[ele.valueKey] === rid.value
                                    }
                                    onChange={(e) =>
                                      handleInputChange(e, ele.id)
                                    }
                                    sx={{
                                      "& .MuiFormControlLabel-label": {
                                        fontSize: "14px",
                                      },
                                    }}
                                    control={
                                      <Radio size="small" color="primary" />
                                    }
                                  />
                                );
                              })}
                            </RadioGroup>
                          </FormControl>
                        ) : (
                          <Typography className={`${styles.formFont}`}>
                            <span>{ele.title}</span>
                          </Typography>
                        )}
                        {jobConfigMode !== "view" && formData[ele.valueKey] ? (
                          <div
                            className={`flexDisplayColumn ${styles.uploadBox} ${styles.solidGreyBorder}`}
                          >
                            {formData[ele.valueKey] === "fileUpload" ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  rowGap: "25px",
                                }}
                              >
                                {ele.childObj.fileUpload?.map((rid, index) =>
                                  rid.type === "radio" ? (
                                    radioGroup(
                                      "fileUpload",
                                      index,
                                      rid,
                                      formData[rid.valueKey],
                                      {
                                        color: "#2E2E2E",
                                        marginBottom: "26px",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        "&.Mui-focused": {
                                          color: "#2E2E2E",
                                        },
                                      },
                                      {
                                        fontSize: "14px",
                                      },
                                      {
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "14px",
                                        },
                                      }
                                    )
                                  ) : (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        columnGap: "23px",
                                      }}
                                    >
                                      {rid.list?.map((bid, i) =>
                                        bid.id === "b1"
                                          ? templateButton(
                                              "fileUpload",
                                              i,
                                              bid,
                                              locationDataTemplate
                                            )
                                          : browseButton(
                                              "fileUpload",
                                              i,
                                              bid,
                                              locationFileInputRef
                                            )
                                      )}
                                    </div>
                                  )
                                )}
                                {selectedLocationFile.length > 0 && (
                                  <div
                                    className={`flexDisplay ${styles.selectedAttachmentsContainer}`}
                                  >
                                    <img src={fileIcon} alt="file" />
                                    {selectedLocationFile.map((file, index) => (
                                      <>
                                        <div
                                          key={index}
                                          className={styles.selectedAttachment}
                                        >
                                          {file.name}
                                        </div>
                                        {/* <button
                                        className={styles.fileCloseBtn}
                                        onClick={() =>
                                          removeSelectedLocationFile(index)
                                        }
                                      >
                                        <img src={closeSvg} alt="close" />
                                      </button> */}
                                      </>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  rowGap: "25px",
                                }}
                              >
                                {ele.childObj.manualUpload?.map((rid, index) =>
                                  rid.type === "radio" ? (
                                    radioGroup(
                                      "manualUpload",
                                      index,
                                      rid,
                                      formData[rid.valueKey],
                                      {
                                        color: "#2E2E2E",
                                        marginBottom: "26px",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        "&.Mui-focused": {
                                          color: "#2E2E2E",
                                        },
                                      },
                                      {
                                        fontSize: "14px",
                                      },
                                      {
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "14px",
                                        },
                                      }
                                    )
                                  ) : rid.type === "dropdown" ? (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        rowGap: "16px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {rid.title}
                                      </div>
                                      <AutoSelect
                                        data={formData}
                                        setData={setFormData}
                                        disabled={rid.isDisabled}
                                        id={rid.valueKey}
                                        multipleFlag={rid.multipleFlag}
                                        placeHolder={rid.placeHolder}
                                        list={rid.list}
                                        width="75%"
                                        searchText="locationSearch"
                                      />
                                    </div>
                                  ) : rid.type === "chips" &&
                                    formData[rid.valueKey].length > 0 ? (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        rowGap: "14px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {rid.title}
                                      </div>
                                      <div
                                        className={`flexDisplay`}
                                        style={{
                                          columnGap: "8px",
                                          rowGap: "8px",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {formData[rid.valueKey].length > 0 &&
                                          formData[rid.valueKey]
                                            ?.slice(0, 10)
                                            .map((e, i) => (
                                              <span
                                                key={i}
                                                className={`${styles.chip} widthMaxContent flexDisplay`}
                                                style={{
                                                  columnGap: "18px",
                                                  backgroundColor: "#E7F0F9",
                                                }}
                                              >
                                                {e.name}
                                                <button
                                                  onClick={(el) => {
                                                    el.preventDefault();
                                                    removeSelectedLocationFile(
                                                      "manualUpload",
                                                      rid.valueKey,
                                                      e
                                                    );
                                                  }}
                                                  style={{
                                                    border: "none",
                                                    padding: "0",
                                                    background: "none",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <CloseRounded
                                                    style={{
                                                      width: "14px",
                                                      height: "14px",
                                                    }}
                                                  />
                                                </button>
                                              </span>
                                            ))}
                                        {formData[rid.valueKey].length > 10 && (
                                          <button
                                            className={styles.showMoreBtn}
                                            style={{ background: "inherit" }}
                                            onClick={() =>
                                              setShowLocationList(true)
                                            }
                                          >
                                            +
                                            {formData[rid.valueKey].length - 10}{" "}
                                            more
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  ) : null
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <LocationComponent
                            showLocationList={showLocationList}
                            getData={getData}
                            setShowLocationList={setShowLocationList}
                          />
                        )}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              )}
              <Grid
                item
                xs={12}
                container
                className={`${styles.cardContainer}`}
              >
                {cardFour?.map((ele, id) => (
                  <Grid key={id} item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "24px",
                      }}
                    >
                      <Typography
                        className={`${styles.formFont} justifyContentSpaceBetween`}
                      >
                        <span
                          className={`flexDisplayColumn fontWeight500`}
                          style={{
                            rowGap: "15px",
                          }}
                        >
                          <div className="flexDisplay">
                            <span>{ele.title}</span>
                            {jobConfigMode === "edit" &&
                              !!formData.is_mpa_enable &&
                              !!ele.isLock && (
                                <span
                                  style={{
                                    marginLeft: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <LockOutlined
                                    style={{
                                      color: "#757575",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                </span>
                              )}
                          </div>
                          <div
                            className={`${styles.greydedText}`}
                            style={{ fontSize: "14px" }}
                          >
                            {ele.placeHolder}
                          </div>
                        </span>
                        {jobConfigMode !== "view" && (
                          <BlueSwitch
                            {...label}
                            checked={isMpaEnable ? true : false}
                            onChange={(e) => handleChange(e, ele.valueKey)}
                            inputProps={{ "aria-label": "controlled" }}
                            disabled={ele.isDisabled}
                          />
                        )}
                      </Typography>
                      {!!isMpaEnable && jobConfigMode !== "create" && (
                        <div
                          className={`${styles.textBoxView} ${
                            jobConfigMode === "view"
                              ? styles.blueBackground
                              : ""
                          } fontSize16 fontWeight500`}
                        >
                          {ele.childArr?.map((obj, index) => (
                            <div
                              key={index}
                              className={`flexDisplayColumn`}
                              style={{ rowGap: "24px" }}
                            >
                              <div style={{ marginTop: "2px" }}>
                                {obj.title}
                              </div>
                              <div
                                className={`${styles.textBoxView} ${
                                  jobConfigMode === "view"
                                    ? styles.blueOutline
                                    : styles.textBoxViewDisable
                                } flexDisplay justifyContentSpaceBetween`}
                                style={{ alignItems: "center" }}
                              >
                                {jobConfigMode === "view" ? (
                                  <a
                                    href={formData[obj.valueKey]}
                                    target="_blank"
                                    className={`${styles.linkTagEnable}`}
                                  >
                                    {formData[obj.valueKey]?.length > 130
                                      ? formData[obj.valueKey]?.substr(0, 127) +
                                        "..." +
                                        formData[obj.valueKey]?.substr(
                                          formData[obj.valueKey]?.length - 3
                                        )
                                      : formData[obj.valueKey]}
                                  </a>
                                ) : (
                                  <span style={{ fontWeight: 400 }}>
                                    {formData[obj.valueKey]}
                                  </span>
                                )}
                                {jobConfigMode === "view" && (
                                  <span
                                    onClick={() =>
                                      copyToClipboard(formData[obj.valueKey])
                                    }
                                  >
                                    <ContentCopy
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </span>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </Box>
                  </Grid>
                ))}
              </Grid>
              {jobConfigMode === "view" && (
                <Grid
                  item
                  xs={12}
                  container
                  sx={{
                    justifyContent: "space-between",
                    rowGap: "40px",
                  }}
                  className={`${styles.cardContainer}`}
                >
                  <AgeRequirement
                    uniqueKey="jobConfig"
                    cardView={cardView1}
                    eligibilityData={eligibilityData}
                  />
                </Grid>
              )}
              {jobConfigMode === "view" && eligibilityData && (
                <Grid
                  item
                  xs={12}
                  container
                  sx={{
                    justifyContent: "space-between",
                    rowGap: "40px",
                  }}
                >
                  {cardView2?.map((ele, id) => (
                    <Grid
                      key={id}
                      item
                      sx={{
                        flex: "0 0 49%",
                        maxWidth: "49%",
                      }}
                      className={`${styles.cardContainer}`}
                    >
                      <GenderLanguage
                        uniqueKey="jobConfig"
                        data={ele}
                        eligibilityData={eligibilityData}
                        setShowLanguageList={setShowLanguageList}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
              {jobConfigMode === "view" && eligibilityData && (
                <Grid item xs={12} container sx={{ rowGap: "24px" }}>
                  {cardView3and4?.map((ele, id) => (
                    <Grid
                      item
                      xs={12}
                      key={id}
                      className={`${styles.cardContainer}`}
                    >
                      <EducationAssetRequirement
                        uniqueKey="jobConfig"
                        data={ele}
                        eligibilityData={eligibilityData}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>
          </Box>
          {jobConfigMode !== "view" && (
            <Footer
              uniqueKey="jobConfig"
              isLoading={isLoading}
              button1="Cancel"
              button2="Next"
              linkButton1="/jobsdb"
              handleSaveBtn={handleSaveBtn}
              isDisabled={!goodToSave || isLoading}
            />
          )}
          {showLocationList && (
            <LocationModal
              uniqueKey="viewEditLocation"
              caption="Locations"
              openAdminNotes={showLocationList}
              setOpenAdminNotes={setShowLocationList}
              inForm={true}
              modelList={
                jobConfigMode === "view"
                  ? getData.locationArray
                  : formData.locations
              }
              removeSelectedElement={removeSelectedLocationFile}
            />
          )}
          {showLanguageList && (
            <LocationModal
              uniqueKey="viewLanguage"
              caption="Languages"
              openAdminNotes={showLanguageList}
              setOpenAdminNotes={setShowLanguageList}
              inForm={true}
              modelList={eligibilityData.language}
            />
          )}
        </>
      )}
    </>
  );
};
export default JobConfigForm;
